<template>
  <footer id="footer" :style="'background-color:'+bgcolor2">
    <div class="container" >
      <div class="footer-left" style="height:100px;">
        <!-- <img src="../../static/Upload/arr2_icon.png" style="max-height: 100px; min-height: 100px;margin-bottom:30px;" mode="widthFix" alt=""/> -->
        <!-- <img :src="logoUrl2" style="max-height: 100px; min-height: 100px;margin-bottom:30px;" mode="widthFix" alt=""/> -->
      </div>
      <div class="footer-left" >
        <ul class="cont_ul cont_start_column">
          <li>名称：{{email}}</li>
          <li>地址：{{addr}}</li>
          <li>电话：{{phone}}</li>
        </ul>
      </div>
      <div class="footer-right" style="margin-bottom:20px;">
        <img :src="android" class="cont_ewm_img" alt="" style="margin-right:20px;"/>
        <img :src="ios" class="cont_ewm_img" alt="" style="margin-right:20px;"/>
        <img src="../../static/Upload/erweima.png" class="cont_ewm_img" alt="" style="margin-right:20px;"/>
        <img :src="contactUrl" class="cont_ewm_img" alt=""/>
      </div>
    </div>
    <div style="width: 100%;background: #333;color: #fff;padding: 10px;text-align: center;font-size:14px;margin:0 auto;" >
      <div class="container cont_back" style="margin:0 auto;width:100%;text-align:center;">
        <!-- <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011202000564" target="blank">苏公安网备32011202000564号</a></span> -->
        <!-- <span><a href="https://beian.miit.gov.cn/" target="blank">苏ICP备2021002144号</a></span> -->
        <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011202000564" target="blank">{{sites.copyrightLogin1}}</a></span>
        <span><a href="https://beian.miit.gov.cn/" target="blank">{{sites.copyrightLogin2}}</a></span>
        <!-- <span>Copyright 2020-2021 南京德教思政技术研究中心 提供技术支持</span> -->
        <span>{{sites.copyrightFoot}}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      android: '',
      ios: '',
      contactUrl: '',
      addr: '',
      phone: '',
      email: '',
      logoUrl2: '',
      bgcolor2: '',
      sites:[],
    }
  },
  methods: {
    // 获取网站信息
    getSiteInfo () {
      let that = this
      that.$http.ajax(that.$http.getSiteInfo, {}, function (res) {

        that.contactUrl = res.result.contactUrl
        that.addr = res.result.addr
        that.phone = res.result.phone
        that.email = res.result.email
        that.logoUrl2 = res.result.logoUrl2
        that.bgcolor2 = res.result.bgcolor2
        that.android = res.result.android
        that.ios = res.result.ios
        window.localStorage.setItem("SiteInfo", JSON.stringify(res.result));
      })
    }
  },
  mounted () {
    if(!localStorage.getItem("SiteInfo")){
      this.getSiteInfo();
    }else{
      let that = this
      var SiteInfos = JSON.parse(window.localStorage.getItem("SiteInfo"));
console.log('[[]]',SiteInfos)
      that.sites = SiteInfos
      that.contactUrl = SiteInfos.contactUrl
      that.addr = SiteInfos.addr
      that.phone = SiteInfos.phone
      that.email = SiteInfos.email
      that.logoUrl2 = SiteInfos.logoUrl2
      that.bgcolor2 = SiteInfos.bgcolor2
      that.android = SiteInfos.android
      that.ios = SiteInfos.ios
    }
  }
}
</script>

<style scoped lang="less">
.footer-left{
  float: left ;
  display: block ;
  margin-right: 50px;
}
.cont_back span{
  // float: right;
  margin-left: 20px;
  font-size: 12px;
  text-align: center;
}
  #footer{
    width: 100%;
    box-sizing: border-box;
    position: relative;
    // bottom: 0;
  }
  .cont_ul {
    width: 100%;
  }
  .cont_li2 {
    width: 100%;
    height: 129px;
    margin-left: 15px;
    margin-right: 15px;
    background: #fff;
  }
  .cont_ul li {
    margin: 5px 0;
  }
  .cont_ewm_img {
    width: 100px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue